// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  production: true,
  chatURI: 'https://club-chat.margo.me/', 
  apiUrl: 'https://club-admin-api.margo.me/', 
  segmentationApiUrl: 'https://club-segment.margo.me/', 
  dsURL:'https://crm.margo.me/',
  accessKeyId: 'AKIA3AFAXT7OT4APBLFU',
  secretAccessKey: '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',

  region: 'us-east-1',
  cbAccessKeyId: 'AKIA3AFAXT7OT4APBLFU',
  cbSecretAccessKey: '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',
  cbRegion: 'us-east-1',
  cbBucket: 'margous-cb',
  // SFDomainURL: 'https://000000111111111111111111--dev.lightning.force.com',

  // SFDomainURL: 'https://000000111111111111111111--dev.sandbox.lightning.force.com/',
  SFDomainURL: 'https://mar-go-aditatechnologies-dev-ed.lightning.force.com',

  awsBucket: 'margous-me-2',
  projectName: 'marGo',
  awsKey: 'margo',
  product_catalogue_path: 'Products/dev/',
  awsUrl:'https://margous-me-2.s3.amazonaws.com'
};

